import { Vue, Component } from 'vue-property-decorator';


@Component({
    name: 'discover',
})

export default class Discoverable extends Vue {
    // ---------------------------------------------------------------------
    // Properties

    public getBackFlow() {
        this.$router.push('/dashboard');
    }
}
